import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { useToast } from '../../../components/Toast';
import { useSelector } from 'react-redux';

const TaskModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Aufgabe hinzufügen', 
  description = 'Geben Sie einen Namen ein und wählen Sie eine Organisation (optional).',
  confirmText = 'Hinzufügen', 
  confirmColor = 'bg-custom-yellow'
}) => {
  const [taskName, setTaskName] = useState('');
  const [selectedOrganization, setSelectedOrganization] = useState('');
  const { addToast } = useToast();
  
  // Get organizations from Redux store
  const { organizations } = useSelector(state => state.organizations);

  useEffect(() => {
    if (isOpen) {
      setTaskName('');
      setSelectedOrganization('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    const trimmedName = taskName.trim();

    if (!trimmedName) {
      addToast('Bitte geben Sie einen gültigen Namen ein', 'error');
      return;
    }

    // Pass both task name and organization_id (null if no organization selected)
    const organizationId = selectedOrganization || null;
    onConfirm(trimmedName, organizationId);
    setTaskName('');
    setSelectedOrganization('');
  };

  return (
    <div className="fixed inset-0 bg-[#D6D6D6B2] bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6 flex flex-col items-center">
          <div className="rounded-full bg-blue-100 p-3 mb-4">
            <Plus className="h-6 w-6 text-blue-600" />
          </div>
          <h2 className="text-xl font-semibold mb-2">{title}</h2>
          <p className="text-gray-600 text-center mb-4">{description}</p>
          
          <div className="w-full space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Aufgabenname *
              </label>
              <input
                type="text"
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Aufgabenname eingeben"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Organisation (optional)
              </label>
              <select
                value={selectedOrganization}
                onChange={(e) => setSelectedOrganization(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Global (für alle Benutzer)</option>
                {organizations.map((org) => (
                  <option key={org.organization_id} value={org.organization_id}>
                    {org.organization_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="flex gap-4 w-full mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
            >
              Abbrechen
            </button>
            <button
              onClick={handleConfirm}
              className={`flex-1 px-4 py-2 ${confirmColor} text-white rounded hover:opacity-90 cursor-pointer transition-colors`}
              disabled={!taskName.trim()}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskModal; 